import { SURVEY_TYPE_COLLECTION_PATH } from '../api/config/EntityCollectionPathMap';
import { buildInternalV2ApiUrl } from '../api/utils/apiUtils';

export default (idList, payload) =>
  idList.map(id => ({
    url: buildInternalV2ApiUrl(`${SURVEY_TYPE_COLLECTION_PATH}/${id}/status`),
    method: 'PATCH',
    payload,
  }));
